import { PumpTypeEnum } from '@authority-labs/enums';
import { InspectionCase } from './inspection-case.dto';

export class InspectionPumpCaseDto extends InspectionCase {
  pumpNumber?: string;
  pumpType?: PumpTypeEnum;
  manufacturerName?: string;
  serialNumber?: string;
  nominalFlow?: string; // gpm
  nominalPressure?: string; // psi
  controlPanelManufacturerName?: string;
  panelModel?: string;
}
export class InspectionPumpCase extends InspectionPumpCaseDto {
  constructor(data: InspectionPumpCaseDto = {}) {
    super(data);
    this.pumpNumber = data.pumpNumber;
    this.pumpType = data.pumpType;
    this.manufacturerName = data.manufacturerName;
    this.serialNumber = data.serialNumber;
    this.nominalFlow = data.nominalFlow;
    this.nominalPressure = data.nominalPressure;
    this.controlPanelManufacturerName = data.controlPanelManufacturerName;
    this.panelModel = data.panelModel;
  }
}
